export default __webpack_public_path__ + "static/media/footstep.cba0fcb9.wav";